import { MessageSquareText, PhoneCall, Home, LayoutDashboard, Lightbulb, Bug, Heart, MessageCircle, Bot } from "lucide-react";

export const SOURCE = {
  sms: { label: "Text", icon: MessageSquareText },
  voice: { label: "Voice call", icon: PhoneCall },
  portal: { label: "Resident portal", icon: Home },
  dashboard: { label: "Dashboard", icon: LayoutDashboard },
};

export const CATEGORY = {
  idea: { label: "Idea", icon: Lightbulb, cls: "bg-amber-50 text-amber-700" },
  problem: { label: "Problem", icon: Bug, cls: "bg-danger-50 text-danger-600" },
  praise: { label: "Praise", icon: Heart, cls: "bg-emerald-50 text-emerald-700" },
  ai_conversation: { label: "About the AI", icon: Bot, cls: "bg-violet-50 text-violet-700" },
  other: { label: "Feedback", icon: MessageCircle, cls: "bg-sand-100 text-ink/70" },
};

export const catOf = (f) => CATEGORY[f.category] || CATEGORY.other;
export const sourceOf = (f) => SOURCE[f.source] || SOURCE.dashboard;

export const fmtFull = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return ""; }
};

export const relTime = (iso) => {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  if (isNaN(diff)) return "";
  const m = Math.floor(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d`;
  try { return new Date(iso).toLocaleDateString([], { month: "short", day: "numeric" }); } catch { return ""; }
};

export const fmtPhone = (p) => {
  if (!p) return "";
  const d = String(p).replace(/[^\d]/g, "").replace(/^1/, "");
  return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : p;
};

export const senderName = (f) => f.name || (f.phone ? fmtPhone(f.phone) : f.email) || "Unknown caller";

// Identical message from the same person collapses into one row ("×3"). Items arrive newest
// first, so `first` is the latest occurrence.
export function groupFeedback(items) {
  const map = new Map();
  const out = [];
  for (const f of items) {
    const who = f.phone || f.email || f.name || f.id;
    const key = `${who}|${(f.message || "").trim().toLowerCase().replace(/\s+/g, " ")}`;
    const g = map.get(key);
    if (g) { g.items.push(f); g.ids.push(f.id); continue; }
    const ng = { id: f.id, first: f, items: [f], ids: [f.id] };
    map.set(key, ng);
    out.push(ng);
  }
  return out;
}

export function dayBucket(iso) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "Older";
  const now = new Date();
  const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startThat = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((startToday - startThat) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return "This week";
  if (days < 30) return "This month";
  return "Older";
}

export const isDesktop = () => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches;
